import React from 'react';

//*files
import WingsIcon from '../../Assets/Images/docs.svg';
import cssClasses from './WingsCard.module.css';

//*MUI
import { Box } from '@mui/material';

function WingsCard({ clicked, wingName }) {
  return (
    <Box className={cssClasses.DivContainer} onClick={clicked}>
      <Box className={cssClasses.InlineDiv}>
        <img src={WingsIcon} alt={''} />
        <Box className={cssClasses.Title}> {wingName.includes('WING')?wingName:<span>Wing {wingName}</span>}</Box>
      </Box>
    </Box>
  );
}

export default WingsCard;
